import type { AutomatedCardsData } from './types';
import { writable } from 'svelte/store';

export const automatedCardsStore = writable<AutomatedCardsData>({ sections: {}, cards: {} });
